import { render, staticRenderFns } from "./invadobay-super-in.vue?vue&type=template&id=31737505&scoped=true"
import script from "./invadobay-super-in.vue?vue&type=script&lang=js"
export * from "./invadobay-super-in.vue?vue&type=script&lang=js"
import style0 from "./invadobay-super-in.vue?vue&type=style&index=0&id=31737505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31737505",
  null
  
)

export default component.exports